module.exports = __webpack_public_path__ + "img/payment-failed.e66ab624.png";